class CareProductList extends HTMLElement {
  options = [];
  currentId;
  variants;
  careList = [];
  isSelected = false;
  constructor() {
    super();
    this.init();
  }

  init() {
    // 初始化数据
    this.initData();
  }

  initData() {
    try {
      this.productTitle = this.dataset.productTitle;
      this.careList = this.dataset.cares ? JSON.parse(this.dataset.cares) : [];
      console.log('初始化数据 careList -------------------', this.careList);
    } catch (error) {
      console.error('初始化错误', error);
    }
  }

  updateSelectProduct() {
    console.log('updateSelectProduct -------------------')
    // 找到被选中的Flying Camera
    const normal = Array.from(
      document.querySelectorAll('.product-normal-option')
    ).find((item) => {
      const input = item.querySelector('input');
      return input && input.checked;
    });
    if (!normal) return;
    console.log('updateSelectProduct -------------------', normal);
    const variantName = normal.dataset.variantName;
    if (variantName) {
      const careProductTags = Array.from(
        this.querySelectorAll('.care-product-container')
      );
      careProductTags.forEach((tag, index) => {
        // care 匹配到matchName 或者变体名称 显示
        if (tag.dataset.matchName == this.productTitle || tag.dataset.matchName == variantName) {
          tag.classList.remove('tw-hidden');
          tag.classList.add('current-care-product');
          // 找到tag 里care-product web component
          const careProduct = tag.querySelector('care-product');
          careProduct.isShow = true;
          
        } else {
          tag.classList.add('tw-hidden');
          tag.classList.remove('current-care-product');
          const careProduct = tag.querySelector('care-product');
          careProduct.isShow = false;
        }
      });
    }
    
  }
}

customElements.define('care-product-list', CareProductList);
